import Image from "next/image";
import CRMask from "../CRMask";
{/* about media 之間的圖片 */}

const CRAboutImgWrap = () =>{
    return(
        <div className={`
            pin-img trans about-img-wrap statue-and-mask 
            fixed top-[100px] left-[50%] m-auto
            w-[678px] h-full min-h-[522px] 
            usm:absolute usm:top-0 usm:left-[unset]
            usm:w-full usm:h-[fit-content] usm:right-0
            usm:translate-x-[100px] usm:translate-y-[-100px]
            usm:scale-[.8] 
        `}>
            {/* 影片遮罩 */}
            <div className="about-mask-container mask-container m-auto max-w-[780px] w-[780px] usm:w-[382px] h-[580px] absolute right-0 top-[111px] translate-x-[63px] usm:top-0">
                <CRMask />
            </div>
            {/* 雕像 */}
            <div className="cr-statue about-statue max-w-[558px] w-[558px] usm:w-[255px] max-h-[821px] h-[fit-content] absolute m-auto top-[410px] usm:top-[296px] right-0 flex justify-center items-center z-[3] ">
                <Image
                    alt="man-image"
                    width={558}
                    height={821}
                    src={"/images/cryptoread/section3/section3.svg"}
                    className="about-statue-img aspect-[558/821] absolute"
                />
            </div>
            {/* 其他線圖 */}
            <div className="about-icons max-w-[597px] w-[558px] usm:w-[293px] max-h-[454px] h-[fit-content] absolute m-auto top-[410px] right-[40px] usm:top-[298px] usm:right-0 flex justify-center items-center z-[3]">
                <Image
                    alt="icon-image"
                    width={597}
                    height={454}
                    src={"/images/cryptoread/section3/section3_icon.svg"}
                    className="aspect-[597/454] absolute "
                />
            </div>
        </div>
    )
}

export default CRAboutImgWrap;